/*
 * © Crown © Crown Copyright 2026. Published by the Royal Government of the Dominion of Atlantis.
 * 
 * Licensed under the Juro Restricted License Version 2. You may not change and/or modify 
 * this work except under the terms of the Juro Restricted License. 
 * See <https://docs.juro.net/legal/JRL_V2_COMPLETE/> for details.
 */

// for translation
cafe._ = function (txt, replace, context = null) {
	if (!txt) return txt;
	if (typeof txt != "string") return txt;

	let translated_text = "";

	let key = txt; // txt.replace(/\n/g, "");
	if (context) {
		translated_text = cafe._messages[`${key}:${context}`];
	}

	if (!translated_text) {
		translated_text = cafe._messages[key] || txt;
	}

	if (replace && typeof replace === "object") {
		translated_text = $.format(translated_text, replace);
	}
	return translated_text;
};

window.__ = cafe._;

cafe.get_languages = function () {
	if (!cafe.languages) {
		cafe.languages = [];
		$.each(cafe.boot.lang_dict, function (lang, value) {
			cafe.languages.push({ label: lang, value: value });
		});
		cafe.languages = cafe.languages.sort(function (a, b) {
			return a.value < b.value ? -1 : 1;
		});
	}
	return cafe.languages;
};
